
import { voteForContent } from './utils.js'
import { getData, voteImage } from './data.js'

import io from 'socket.io-client'

const _io = io
const sock = _io.connect('http://visualdiet.mcsdh.com:3000')

let voteList = new Set()

const body = document.getElementsByTagName('body')[0]

export function popGallery(data) {

  let totalPosVotes = 0
  let resetCount = data.length - 1

  sock.on('image', (data) => {
    setCurrentSlide(data)
  })

  sock.on('vote received', (data) => {
    flashBeacon(data.sentiment)
  })

  const slideContainer = document.querySelector('.js-slides-container')
  slideContainer.innerHTML = ''

  data.forEach((item) => {
    totalPosVotes += item.voteCount
  })

  data.forEach((item, i = 0) => {

    const totalVotePercent = (item.voteCount / totalPosVotes * 100).toFixed(1)

    let itemVotePercentUp = Math.floor((item.voteCount / item.totalVotes * 100))
    let itemVotePercentDown = (itemVotePercentUp < 0) ? itemVotePercentUp + 100 : itemVotePercentUp - 100

    let positiveCopy, negativeCopy, formatPositive, formatNegative

    formatPositive = Math.abs(itemVotePercentUp)
    formatNegative = Math.abs(itemVotePercentDown)

    let voted = voteList.has(item.pID) ? 'visible' : 'hidden'

    if (isNaN(itemVotePercentUp) || voted === 'hidden') {
      positiveCopy = negativeCopy = '<hr class="vote-buttons__divider" />'
    } else {
      positiveCopy = `${formatPositive}%`
      negativeCopy = `${formatNegative}%`
    }

    const ownerDeets = (item.owner) ? item.owner : 'Source unknown'

    const slideData = `
      <div class='slide ${i == 0 ? 'is-visible' : ''}' style="background-image: url(${item.assetURL})" data-vote-percent="${totalVotePercent}" data-content-id="${item.pID}">
          <div class='slide__timer'>
            <span class="slide__time-left" data-timerID="${item.pID}"></span>
          </div>
        
          <div class="vote-buttons">    
              <div class="vote-buttons__item vote-buttons__item--positive js-vote-buttons__item" data-id="${item.pID}">
                  <span class="vote-buttons__score ${voted} js-vote-buttons__score" data-score="${formatPositive}">${positiveCopy}</span>
                  <img class="vote-buttons__media" src="../img/face_happy.svg" alt="I like it">
              </div>

              <div class="vote-buttons__item vote-buttons__item--negative js-vote-buttons__item" data-id="${item.pID}">
                  <span class="vote-buttons__score ${voted} js-vote-buttons__score" data-score="${formatNegative}">${negativeCopy}</span>
                  <img class="vote-buttons__media" src="../img/face_sad.svg" alt="I don't like it">
              </div>
          </div>
          <div class="slide__credit">${ownerDeets}</div>
      </div>`

    slideContainer.innerHTML += slideData

    let votingButtons = document.querySelectorAll('.js-vote-buttons__item')

    votingButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        let vote = (e.target.classList.contains('vote-buttons__item--positive')) ? 'up' : 'down'
        let id = e.target.dataset.id

        voteList.add(id)

        voteForContent(e, id, vote)
        sock.emit('vote', { 'id': id, 'sentiment': vote })

        const container = document.querySelector(`[data-content-id='${id}']`)
        const scores = container.querySelectorAll('.js-vote-buttons__score')
        showScores(scores)
      })
    })

  })

  const showScores = (scores) => {
    scores.forEach((score, i = 0) => {
      score.classList.add('is-visible')
      animateScore(score, score.dataset.score)
    })
  }

  const animateScore = (elem, total) => {
    let currentCount = 0

    let timer = setInterval(() => {
      if (currentCount < total) {
        currentCount++
        elem.innerHTML = `${currentCount}%`
      } else {
        clearInterval(timer)
      }
    }, 25)

  }


  const slides = document.querySelectorAll('.slide')

  const setCurrentSlide = (data) => {

    setTimer(data)

    slides.forEach((slide) => {
      slide.classList.remove('is-visible')
    })

    if (data.num === resetCount) {
      if (body.classList.contains('poster')) {
        window.location = window.location
      } else {
        updateData()
        return
      }
    }

    slides[data.num].classList.add('is-visible')
  }

}

const setTimer = (data) => {
  let timerEl = document.querySelector(`[data-timerID='${data.id}']`)

  if (!timerEl) {
    return
  }

  let currentTime = 0
  let barWidth = 0
  let multiplier = 10

  let countdown = setInterval(() => {
    if (currentTime < data.timer) {
      barWidth = Math.round((currentTime / data.timer) * 100) + multiplier
      timerEl.style.width = `${barWidth}%`
      currentTime += multiplier
    } else {
      clearInterval(countdown)
    }
  }, multiplier)

}


const updateData = () => {
  getData()
}

const beaconContainer = document.querySelector('.js-beacon')

const flashBeacon = (sentiment) => {

  let scale = (((Math.random() * 5) + .5).toFixed(0) / 5)
  let emotion = `<div class="emotion ${sentiment} js-emotion" style="transform: scale(${scale})"></div>`
  beaconContainer.insertAdjacentHTML('beforeend', emotion)

  setTimeout(() => {
    let emo = document.querySelectorAll('.js-emotion')[0]
    beaconContainer.removeChild(emo)
  }, 3000)
}





// WEBPACK FOOTER //
// ./js/slide-show.js